import { getObjectToNumberArray } from './helpers';

export const getInitialAssignedToUsersData = assignedTo => ({
  assign_to: getObjectToNumberArray(assignedTo),
});
